import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import uuid from 'uuid';
import { rebaseTransaction as _rebaseTransaction } from '../common/rebase-transaction';
import { resourceIdFromSourceAndLocalId } from '../utils/ari';
import { convertSyncBlockPMNodeToSyncBlockData } from '../utils/utils';
export var SourceSyncBlockStoreManager = /*#__PURE__*/function () {
  function SourceSyncBlockStoreManager(dataProvider) {
    _classCallCheck(this, SourceSyncBlockStoreManager);
    this.dataProvider = dataProvider;
    this.syncBlockCache = new Map();
  }

  /**
   * Add/update a sync block node to/from the local cache
   * @param syncBlockNode - The sync block node to update
   */
  return _createClass(SourceSyncBlockStoreManager, [{
    key: "updateSyncBlockData",
    value: function updateSyncBlockData(syncBlockNode) {
      var _syncBlockNode$attrs = syncBlockNode.attrs,
        localId = _syncBlockNode$attrs.localId,
        resourceId = _syncBlockNode$attrs.resourceId;
      if (!localId || !resourceId) {
        throw new Error('Local ID or resource ID is not set');
      }
      var syncBlockData = convertSyncBlockPMNodeToSyncBlockData(syncBlockNode);
      this.syncBlockCache.set(localId, syncBlockData);
      return true;
    }

    /**
     * Save content of bodiedSyncBlock nodes in local cache to backend
     *
     * @returns true if saving all nodes successfully, false if fail to save some/all nodes
     */
  }, {
    key: "flushBodiedSyncBlocks",
    value: (function () {
      var _flushBodiedSyncBlocks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var bodiedSyncBlockNodes, bodiedSyncBlockData, resourceIds;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (this.dataProvider) {
                _context.next = 3;
                break;
              }
              throw new Error('Data provider not set');
            case 3:
              bodiedSyncBlockNodes = [];
              bodiedSyncBlockData = [];
              Array.from(this.syncBlockCache.values()).forEach(function (syncBlockData) {
                bodiedSyncBlockNodes.push({
                  type: 'bodiedSyncBlock',
                  attrs: {
                    localId: syncBlockData.blockInstanceId,
                    resourceId: syncBlockData.resourceId
                  }
                });
                bodiedSyncBlockData.push(syncBlockData);
              });
              if (!(bodiedSyncBlockNodes.length === 0)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", Promise.resolve(true));
            case 8:
              _context.next = 10;
              return this.dataProvider.writeNodesData(bodiedSyncBlockNodes, bodiedSyncBlockData);
            case 10:
              resourceIds = _context.sent;
              return _context.abrupt("return", resourceIds.every(function (resourceId) {
                return resourceId !== undefined;
              }));
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", false);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 14]]);
      }));
      function flushBodiedSyncBlocks() {
        return _flushBodiedSyncBlocks.apply(this, arguments);
      }
      return flushBodiedSyncBlocks;
    }())
  }, {
    key: "setEditorView",
    value: function setEditorView(editorView) {
      this.editorView = editorView;
    }
  }, {
    key: "registerConfirmationCallback",
    value: function registerConfirmationCallback(callback) {
      var _this = this;
      this.confirmationCallback = callback;
      return function () {
        _this.confirmationCallback = undefined;
      };
    }
  }, {
    key: "requireConfirmationBeforeDelete",
    value: function requireConfirmationBeforeDelete() {
      return !!this.confirmationCallback;
    }
  }, {
    key: "createSyncBlockNode",
    value: function createSyncBlockNode() {
      var _this$dataProvider;
      var blockInstanceId = uuid();
      var sourceId = (_this$dataProvider = this.dataProvider) === null || _this$dataProvider === void 0 ? void 0 : _this$dataProvider.getSourceId();
      if (!sourceId) {
        throw new Error('Provider of sync block plugin is not set');
      }

      // This should be generated by the data provider implementation as it differs between data providers
      var resourceId = resourceIdFromSourceAndLocalId(sourceId, blockInstanceId);
      var syncBlockNode = {
        attrs: {
          resourceId: resourceId,
          localId: blockInstanceId
        },
        type: 'bodiedSyncBlock'
      };
      return syncBlockNode;
    }
  }, {
    key: "deleteSyncBlocksWithConfirmation",
    value: function () {
      var _deleteSyncBlocksWithConfirmation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(tr, syncBlockIds) {
        var _this2 = this;
        var confirmed, _this$editorView, results;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.confirmationCallback) {
                _context2.next = 19;
                break;
              }
              this.confirmationTransaction = tr;
              _context2.next = 4;
              return this.confirmationCallback();
            case 4:
              confirmed = _context2.sent;
              if (!confirmed) {
                _context2.next = 18;
                break;
              }
              (_this$editorView = this.editorView) === null || _this$editorView === void 0 || _this$editorView.dispatch(this.confirmationTransaction.setMeta('isConfirmedSyncBlockDeletion', true));
              _context2.prev = 7;
              if (this.dataProvider) {
                _context2.next = 10;
                break;
              }
              throw new Error('Data provider not set');
            case 10:
              _context2.next = 12;
              return this.dataProvider.deleteNodesData(syncBlockIds.map(function (attrs) {
                return attrs.resourceId;
              }));
            case 12:
              results = _context2.sent;
              results.forEach(function (result) {
                if (result.success) {
                  // Only delete when it's deleted successfully in backend
                  _this2.syncBlockCache.delete(result.resourceId);
                } else {
                  // TODO: EDITOR-1921 - add error analytics with result.error
                }
              });
              _context2.next = 18;
              break;
            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](7);
            case 18:
              this.confirmationTransaction = undefined;
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[7, 16]]);
      }));
      function deleteSyncBlocksWithConfirmation(_x, _x2) {
        return _deleteSyncBlocksWithConfirmation.apply(this, arguments);
      }
      return deleteSyncBlocksWithConfirmation;
    }()
  }, {
    key: "rebaseTransaction",
    value: function rebaseTransaction(incomingTr, state) {
      if (!this.confirmationTransaction) {
        return;
      }
      this.confirmationTransaction = _rebaseTransaction(this.confirmationTransaction, incomingTr, state);
    }
  }]);
}();